<div class="card border box-shadow-none h-100">
	<img [src]="image" class="card-img-top">
	<div class="card-body">
	  <h3>{{ headline }}</h3>
	  <p class="card-text mb-0">
		<ng-content></ng-content>
	  </p>
	</div> 
  </div>